import * as React from 'react';

var _path, _path2, _path3, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgPaymaster = function SvgPaymaster(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_7609_433)",
        fillOpacity: 0.16,
        d: "M63.051 74H25.615q-1.92 0-3.268-1.347T21 69.385v-50.77q0-1.92 1.347-3.268T25.615 14H49.61l18.058 18.058v37.327q0 1.92-1.347 3.268T63.05 74"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_7609_433)",
        d: "M59.051 70H21.615q-1.92 0-3.268-1.347T17 65.385v-50.77q0-1.92 1.347-3.268T21.615 10H45.61l18.058 18.058v37.327q0 1.92-1.347 3.268T59.05 70m0-2.564q.77 0 1.41-.641.642-.641.642-1.41V29.218L44.449 12.564H21.615q-.768 0-1.41.641-.64.642-.64 1.41v50.77q0 .769.64 1.41.642.64 1.41.64z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint2_linear_7609_433)",
        fillRule: "evenodd",
        d: "M41.074 28.414a2 2 0 0 0-2.828 0L26.414 40.246a2 2 0 0 0 0 2.828l11.832 11.831a2 2 0 0 0 2.828 0l11.832-11.831a2 2 0 0 0 0-2.828zm-11.52 12.89 6.197 6.191 1.597-1.597-4.575-4.575 4.6-4.6-1.622-1.617zm12.754 4.58 1.622 1.617 6.197-6.197-6.197-6.192-1.597 1.598 4.575 4.575z",
        clipRule: "evenodd"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_7609_433",
        x1: 21.487,
        x2: 67.017,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_7609_433",
        x1: 17.487,
        x2: 63.017,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_7609_433",
        x1: 26.117,
        x2: 53.106,
        y1: 41.66,
        y2: 41.66,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgPaymaster as ReactComponent };
//# sourceMappingURL=Paymaster.svg.es.js.map
